module.exports = __webpack_public_path__ + "img/new6.ed1e99f5.png";